export function extractDetailLabels(metafieldsMap) {
    return Object.entries(metafieldsMap)
        .filter(([key, _]) => key.startsWith('custom.detail_icon_'))
        .map(([_, value]) => value as string);
}
